import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

// Emits a JSON-LD <script> into the document head for SEO structured data.
// The "<" escaping keeps a stray "</script>" inside any string value from
// breaking out of the tag.
export default function JsonLd({ data }) {
  const json = JSON.stringify(data).replace(/</g, '\\u003c')
  return (
    <Helmet>
      <script type="application/ld+json">{json}</script>
    </Helmet>
  )
}

JsonLd.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired
}
